import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Icon from '@projeccions-pdc/react-icon';
import * as cx from 'classnames';
import Favorites from '../TopMenu/Favorites';
import Share from '../TopMenu/Share';
import DownloadPDF from '../TopMenu/DownloadPDF';
import getNavigation from '../../Home/Charly/navigationHelper';
import CharlyDrawer from '../../Home/Charly/CharlyDrawer';
import CharlyMenu from '../../Home/Charly/Menu';
import { isDeviceOnline, isAdminOrEditor, isSmartphone } from '../../../helpers';
// import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Loader from '../Loader';
import './Menu.css';

class Menu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            menuOpen: false,
            scrollUp: true,
        };
    }

    handleSizeChange = (match) => {
        this.setState({ smartphoneView: match, menuOpen: false });
    };

    async componentDidMount() {
        isSmartphone((match) => this.handleSizeChange(match));
        await this.refreshOnline();
    }

    componentDidUpdate(prevProps) {
        if (
            this.props.currentContent &&
            prevProps.currentContent &&
            this.props.currentContent.contentId !== prevProps.currentContent.contentId
        ) {
            this.refreshOnline();
        }
    }

    refreshOnline = async () => {
        let isOnline = await isDeviceOnline();
        this.setState({ isOnline });
    };

    handleMenuOpen = () => {
        this.setState({ menuOpen: !this.state.menuOpen });
    };

    handleInsideBackendClick = (frame) => {
        let url = this.context.router.route.match.url;
        if (frame === 'backend') {
            if (url.indexOf('edit') === -1) {
                url = '/category/show';
            } else {
                url = url.replace('edit', 'show');
            }
        } else {
            url = url.replace('show', 'edit');
        }
        this.context.router.history.push(url);
    };

    handleGoToCharlySection = (sectionIdx) => {
        const navigation = getNavigation(this.state.smartphoneView, this.props.notify, this.state.isOnline);
        let id = navigation[sectionIdx].id;
        this.props.history.push(`/home#${id}`);
    };

    handleClickAway = () => {
        this.setState({ menuOpen: false });
    };

    render = () => {
        const navigation = getNavigation(this.state.smartphoneView, this.props.notify, this.state.isOnline);

        return (
            <div>
                {this.state.smartphoneView === true ? (
                    <CharlyDrawer navigation={navigation} handleSetActive={this.handleGoToCharlySection}>
                        <div
                            data-id="navigation-menu-button"
                            className={cx({ 'menu-button': true }, { 'menu-scrollUp': !this.props.scrollUp })}
                        >
                            <div className="right-menu-item">
                                <Icon name="md-apps" primaryColor="#FFF" size="32px" padding={5} />
                            </div>
                        </div>
                    </CharlyDrawer>
                ) : (
                    <div
                        data-id="navigation-menu-button"
                        className={cx({ 'menu-button': true }, { 'menu-scrollUp': !this.props.scrollUp })}
                        onClick={this.handleMenuOpen}
                    >
                        <div className="right-menu-item">
                            <Icon name="md-apps" primaryColor="#FFF" size="32px" padding={5} />
                        </div>
                    </div>
                )}
                {this.state.menuOpen && (
                    <CharlyMenu navigation={navigation} handleSetActive={this.handleGoToCharlySection} />
                    // <ClickAwayListener onClickAway={this.handleClickAway}>
                    //     <CharlyMenu navigation={navigation} handleSetActive={this.handleGoToCharlySection} />
                    // </ClickAwayListener>
                )}

                <div className={cx({ 'right-menu': true }, { 'menu-scrollUp': !this.props.scrollUp })}>
                    {/* <div className='right-menu-item'>
                        <Icon name='md-search' primaryColor='#FFF' size='24px' padding={9} />
                    </div> */}

                    {this.state.isOnline === true && this.props.isInside === true && (
                        <Favorites currentContent={this.props.currentContent}>
                            {(isFav) => (
                                <Fragment>
                                    {/* {'|'} */}
                                    <div className="right-menu-item">
                                        <Icon
                                            name={isFav === true ? 'md-star' : 'md-star-outline'}
                                            primaryColor="#FFF"
                                            size="24px"
                                            padding={9}
                                        />
                                    </div>
                                    {'|'}
                                </Fragment>
                            )}
                        </Favorites>
                    )}

                    {this.props.isInside && this.state.isOnline === true && (
                        <>
                            {this.props.currentContent && this.props.currentContent.contentType !== 'c' && (
                                <>
                                    <DownloadPDF currentContent={this.props.currentContent} notify={this.props.notify}>
                                        {(loading) => (
                                            <div className="right-menu-item">
                                                {loading === true ? (
                                                    <Loader loading={true} primaryColor="#FFF" size="24px" padding={9} />
                                                ) : (
                                                    <Icon name={'md-picture-as-pdf'} primaryColor={'#FFF'} size="24px" padding={9} />
                                                )}
                                            </div>
                                        )}
                                    </DownloadPDF>
                                    |
                                </>
                            )}
                            <Share currentContent={this.props.currentContent} notify={this.props.notify}>
                                {(loading) => (
                                    <div
                                        className="right-menu-item"
                                        style={{
                                            cursor:
                                                this.props.currentContent && this.props.currentContent.contentType !== 'c'
                                                    ? 'pointer'
                                                    : 'default',
                                        }}
                                    >
                                        {loading === true ? (
                                            <Loader loading={true} primaryColor="#FFF" size="24px" padding={9} />
                                        ) : (
                                            <Icon
                                                name={'md-share'}
                                                primaryColor={
                                                    this.props.currentContent && this.props.currentContent.contentType !== 'c'
                                                        ? '#FFF'
                                                        : '#888'
                                                }
                                                size="24px"
                                                padding={9}
                                            />
                                        )}
                                    </div>
                                )}
                            </Share>
                        </>
                    )}
                    {isAdminOrEditor() === true && this.state.isOnline === true ? '|' : ''}
                    {isAdminOrEditor() === true && this.state.isOnline === true ? (
                        <div
                            className="right-menu-item"
                            data-id="editContentButton"
                            onClick={() => {
                                this.handleInsideBackendClick('inside');
                            }}
                        >
                            <Icon name="md-edit" primaryColor="#FFF" size="24px" padding={9} />
                        </div>
                    ) : (
                        ''
                    )}
                </div>
            </div>
        );
    };
}
Menu.propTypes = {
    scrollUp: PropTypes.bool.isRequired,
    isInside: PropTypes.bool.isRequired,
    currentContent: PropTypes.object,
    notify: PropTypes.func.isRequired,
    history: PropTypes.object,
};
Menu.contextTypes = {
    router: PropTypes.shape({
        history: PropTypes.shape({
            push: PropTypes.func.isRequired,
            replace: PropTypes.func.isRequired,
        }).isRequired,
        staticContext: PropTypes.object,
    }).isRequired,
};

export default Menu;
